var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.599 19.844V12.0543C15.599 10.1363 13.773 8.74115 11.8551 8.71946C10.0445 8.69898 8.2858 9.9095 8.28776 11.7202C8.29012 13.8961 8.4783 16.0699 8.85128 18.217L9.10162 19.6581C9.22323 20.3581 8.69312 21 7.99335 21H7.58126C5.82539 21 4.12743 20.3619 2.79427 19.2011L2.31255 18.7816C1.97651 18.489 1.90149 17.9909 2.13607 17.6096L2.52903 16.9709C3.47562 15.4323 4.08745 13.706 4.32349 11.9075L4.94805 7.1491C5.41008 3.62895 8.36596 1 11.8618 1H12.2556C12.9608 1 13.6311 1.23271 14.1779 1.64235C14.9577 2.22665 15.704 2.94289 16.6545 3.15747C18.1522 3.49556 19.2536 4.79269 19.3629 6.34727L19.9165 14.2214C20.0166 15.645 20.6974 16.9615 21.7945 17.8531C22.0626 18.071 22.0695 18.4829 21.8088 18.7099L21.0325 19.3858C19.8362 20.4274 18.3126 21 16.737 21C16.1085 21 15.599 20.4824 15.599 19.844Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair);
export default __webpack_public_path__ + "static/media/hair.4a4baab2810b3b3c45630920654fbe54.svg";
export { ForwardRef as ReactComponent };